import React from "react";
import "./Textbox.css";

const Textbox = ({heading, text}) => {
  // Split text by double line breaks to create paragraphs
  const paragraphs = text.split('\n\n').filter(paragraph => paragraph.trim());

  const formatText = (text) => {
    // Check if this paragraph contains bullet points
    if (text.includes('•')) {
      // Split by bullet points and format as a list
      const lines = text.split('\n');
      return (
        <div className="faq-list">
          {lines.map((line, index) => {
            if (line.trim().startsWith('•')) {
              // This is a bullet point - format as a list item
              return (
                <div key={index} className="faq-item">
                  <div className="faq-question">
                    {line.replace('•', '').trim()}
                  </div>
                </div>
              );
            } else if (line.trim()) {
              // This is an answer - format as answer text
              return (
                <div key={index} className="faq-answer">
                  {line.trim()}
                </div>
              );
            }
            return null;
          })}
        </div>
      );
    } else {
      // Regular paragraph formatting
      return (
        <p className="text-paragraph">
          {text.split('\n').map((line, lineIndex) => (
            <React.Fragment key={lineIndex}>
              {line}
              {lineIndex < text.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      );
    }
  };

  return (
    <>
    <div className="home">
      <div className="home__container">
      
            <h3 className="heading">{heading}</h3>
            <div className="text">
              {paragraphs.map((paragraph, index) => (
                <div key={index}>
                  {formatText(paragraph)}
                </div>
              ))}
            </div>
            
      </div>
    </div>
</>
  );
};

export default Textbox;
